import { isLocalePhoneSupported } from "@faire/help-center-self-serve/utils/isLocalePhoneSupported";
import { browserLevelLocaleKey } from "@faire/help-center-utils/serialized-data/getLocale";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

interface PhoneLanguageNoticeProps {
  textColor: string;
}

export const PhoneLanguageNotice: React.FC<PhoneLanguageNoticeProps> = ({
  textColor,
}) => {

  if (isLocalePhoneSupported(browserLevelLocaleKey())) {
    return null;
  }

  return (
    <>
      <Spacer height="1x" />
      <Typography color={textColor}>
        <StrictLocalMsg
          defaultMessage="Available in English"
          description={{
            text: "describe the phone language supported in English",
          }}
        />
      </Typography>
    </>
  );
};
